import { ALPHA_2_ISO_3166 } from 'cpool-constants';
import { z } from 'zod';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#anschrift

	{
		"strasse": String,
		"hausnummer": String,
		"plz": String,
		"ort": String,
		"land": Country
	}

*/

export const schemaEuropaceAnschrift = z.object({
    hausnummer: z.optional(z.string()),
    land: z.optional(z.nativeEnum(ALPHA_2_ISO_3166)),
    ort: z.optional(z.string()),
    plz: z.optional(z.string()),
    strasse: z.optional(z.string()),
});

export type SchemaEuropaceAnschrift = z.infer<typeof schemaEuropaceAnschrift>;
